module.exports = __webpack_public_path__ + "static/media/undraw_forgot_password_gi2d.24021047.svg";